import apiFetch, { getAuthHeaders } from "../../../shared/services/apiClient";

// ── Notificaciones ────────────────────────────────────────────────────────────

export async function getNotificaciones() {
  const res = await apiFetch("/api/core/portal/notificaciones/");
  if (!res.ok) throw new Error("Error al cargar notificaciones");
  return res.json();
}

export async function marcarTodasLeidas() {
  await apiFetch("/api/core/portal/notificaciones/", { method: "PATCH" });
}

export async function marcarLeida(pk) {
  await apiFetch(`/api/core/portal/notificaciones/${pk}/`, { method: "PATCH" });
}

// ── Estado de cuenta ──────────────────────────────────────────────────────────

export async function getEstadoCuenta() {
  const res = await apiFetch("/api/core/portal/estado-cuenta/");
  if (!res.ok) throw new Error("Error al cargar estado de cuenta");
  return res.json();
}

// ── Áreas comunes ─────────────────────────────────────────────────────────────

export async function getAreas() {
  const res = await apiFetch("/api/core/portal/areas/");
  if (!res.ok) throw new Error("Error al cargar áreas");
  return res.json();
}

export async function createArea(formData) {
  const BASE_URL = process.env.REACT_APP_API_URL ?? "";
  const res = await fetch(`${BASE_URL}/api/core/portal/areas/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateArea(pk, formData) {
  const BASE_URL = process.env.REACT_APP_API_URL ?? "";
  const res = await fetch(`${BASE_URL}/api/core/portal/areas/${pk}/`, {
    method: "PATCH",
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteArea(pk) {
  const res = await apiFetch(`/api/core/portal/areas/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar área");
}

// ── Horarios ──────────────────────────────────────────────────────────────────

export async function createHorario(data) {
  const res = await apiFetch("/api/core/portal/horarios/", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateHorario(pk, data) {
  const res = await apiFetch(`/api/core/portal/horarios/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteHorario(pk) {
  const res = await apiFetch(`/api/core/portal/horarios/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar horario");
}

// ── Disponibilidad ────────────────────────────────────────────────────────────

export async function getDisponibilidad(areaId, year, month) {
  const res = await apiFetch(`/api/core/portal/disponibilidad/?area=${areaId}&year=${year}&month=${month}`);
  if (!res.ok) throw new Error("Error al cargar disponibilidad");
  return res.json();
}

// ── Reservaciones ─────────────────────────────────────────────────────────────

export async function getReservaciones(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/reservaciones/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar reservaciones");
  return res.json();
}

export async function crearReservacion(formData) {
  const BASE_URL = process.env.REACT_APP_API_URL ?? "";
  const res = await fetch(`${BASE_URL}/api/core/portal/reservaciones/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function revisarReservacion(pk, payload) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function cambiarFechaReservacion(pk, nueva_fecha) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/cambiar-fecha/`, {
    method: "PATCH",
    body: JSON.stringify({ nueva_fecha }),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function getCuentasIngreso() {
  const res = await apiFetch("/api/core/portal/cuentas-ingreso/");
  if (!res.ok) throw new Error("Error al cargar cuentas de ingreso");
  return res.json();
}

export async function cancelarReservacion(pk) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify({ estado: "CANCELADA" }),
  });
  if (!res.ok) throw new Error("Error al cancelar reservación");
}

// ── Avisos de pago ────────────────────────────────────────────────────────────

export async function getAvisosPago(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/avisos-pago/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar avisos de pago");
  return res.json();
}

export async function crearAvisoPago(formData) {
  const BASE_URL = process.env.REACT_APP_API_URL ?? "";
  const res = await fetch(`${BASE_URL}/api/core/portal/avisos-pago/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function revisarAvisoPago(pk, estado) {
  const res = await apiFetch(`/api/core/portal/avisos-pago/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify({ estado }),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteAvisoPago(pk) {
  const res = await apiFetch(`/api/core/portal/avisos-pago/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar aviso de pago");
}

// ── Avisos admin ──────────────────────────────────────────────────────────────

export async function getAvisos(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/avisos/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar avisos");
  return res.json();
}

export async function crearAviso(formData) {
  const BASE_URL = process.env.REACT_APP_API_URL ?? "";
  const res = await fetch(`${BASE_URL}/api/core/portal/avisos/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteAviso(pk) {
  const res = await apiFetch(`/api/core/portal/avisos/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar aviso");
}

// ── Residentes ────────────────────────────────────────────────────────────────

export async function getResidentes() {
  const res = await apiFetch("/api/core/portal/residentes/");
  if (!res.ok) throw new Error("Error al cargar residentes");
  return res.json();
}

export async function crearResidente(data) {
  const res = await apiFetch("/api/core/portal/residentes/", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateResidente(pk, data) {
  const res = await apiFetch(`/api/core/portal/residentes/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteResidente(pk) {
  const res = await apiFetch(`/api/core/portal/residentes/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar residente");
}
